/*
    © Copyright LinkHMS B.V. All rights reserved.
    * Proprietary and confidential.
    * Unauthorized copying of this file, via any medium is strictly prohibited.
*/
// angular
import { NgModule } from '@angular/core';
// components
import { BrowserModule } from '@angular/platform-browser';
import { TranslatesBrowserModule } from '@core/i18n/translates-browser/translates-browser.module';

import { AppComponent } from './app.component';
import { AppModule } from './app.module';

@NgModule({
  bootstrap: [AppComponent],
  imports: [AppModule, BrowserModule, TranslatesBrowserModule],
  providers: [{ provide: 'ORIGIN_URL', useValue: location.origin }],
})
export class AppBrowserModule {}
